// extracted by mini-css-extract-plugin
export default {"AboutUs":"AboutUs_AboutUs__9nnsD","content":"AboutUs_content__8cuaw","item":"AboutUs_item__lvico"};